// extracted by mini-css-extract-plugin
module.exports = {"dialogMargin":"FullScreenModal_dialogMargin__8ND4l","modalContainer":"FullScreenModal_modalContainer__FaE27","modalTitle":"FullScreenModal_modalTitle__FCHPZ"};